import { render, staticRenderFns } from "./CompetitorCreate.vue?vue&type=template&id=38949ef0"
import script from "./CompetitorCreate.vue?vue&type=script&lang=js"
export * from "./CompetitorCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports